import React, { useEffect, useState } from 'react';

import { SearchOutlined } from '@ant-design/icons';

import Input from 'components/lib/Input';
import { useDebounce } from 'utils/hooks/useDebounce';

import { useCommunitiesContext } from './CommunitiesContext';

const CommunitiesControlsSearch = () => {
  const { filters, setFilters } = useCommunitiesContext();
  const [search, setSearch] = useState('');

  const debouncedSearch = useDebounce(search);

  useEffect(() => {
    setFilters({ ...filters, search: debouncedSearch });
  }, [debouncedSearch]);

  return (
    <Input
      prefix={<SearchOutlined />}
      style={{ width: '550px' }}
      value={search}
      onChange={(event: any) => setSearch(event.target.value)}
      placeholder="Search by community, company, address or competitors"
    />
  );
};

export default CommunitiesControlsSearch;
